import { NavLink, useLocation } from "react-router-dom";
import { motion } from "framer-motion";

const MetaMask = props => {
  const handleMetamaskClick = async() => props.setModal({enabled:true, message:"Purchases from this website are paused. The launch will take place on Artblocks.io!"});
  return (
    <div className="buttons is-right ">
      <button onClick={handleMetamaskClick} className={"metamask button is-size-7 is-primary is-rounded is-outlined" + (props.isNegative ? " is-inverted" : "")}>Connect to Metamask</button> 
    </div>
  )
}

const Header = props => {
  const location = useLocation();
  let isNegative = false;
  if (location.pathname === `${process.env.PUBLIC_URL}/` || location.pathname === `${process.env.PUBLIC_URL}`) { isNegative = true; }
  const handleBuyClick = e => {
    e.preventDefault();
    props.setModal({enabled:true, message:"Purchases from this website are paused. The launch will take place on Artblocks.io!"});
  } 
    return (
      <motion.section 
        className="section"
        initial={{y:-100, opacity:0}}
        animate={{y:0, opacity:1}}
        transition={{delay:0.2, duration:0.5}}
      >
          <div className={"columns" + (isNegative ? "" : " has-text-black")}>
  
            <div className="column is-3">
              <NavLink 
                to={`${process.env.PUBLIC_URL}/`} 
                activeClassName={"is-active"}
                className={"is-size-4 sp-logo" + (isNegative ? "" : " has-text-black")}>
                Spectron
              </NavLink>
            </div>
            <div className="column is-6">
              <div className="buttons is-centered nav is-size-7">
                <NavLink 
                  to={`${process.env.PUBLIC_URL}/about`}
                  className={"button is-size-7 is-primary is-rounded is-outlined" + (isNegative ? " is-inverted" : "")}>
                  About
                </NavLink>
                <NavLink 
                  to={`${process.env.PUBLIC_URL}/gallery`}
                  className={"button is-size-7 is-primary is-rounded is-outlined" + (isNegative ? " is-inverted" : "")}>
                  Gallery
                </NavLink>
                <NavLink
                  to={`${process.env.PUBLIC_URL}/buy`}
                  className={"button is-size-7 is-primary is-rounded is-outlined" + (isNegative ? " is-inverted" : "")} 
                  disabled={true}
                  onClick={handleBuyClick}
                  >
                Buy
                </NavLink>
              </div>
            </div>

            <div className="column is-3 is-hidden-mobile">
              <MetaMask 
                isNegative={isNegative} 
                setModal={props.setModal}
              />
            </div>

          </div>
      </motion.section>
    )
  };

  export default Header;